import { render, staticRenderFns } from "./NotificationHistory.vue?vue&type=template&id=1770bd4e&"
import script from "./NotificationHistory.vue?vue&type=script&lang=js&"
export * from "./NotificationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports